module.exports = __webpack_public_path__ + "static/infrastructure-48600a43b340423fac7f71ed55118035.png";